import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'react-bootstrap';
import { ORDER_LIST } from './routes';
import moment from 'moment';
import MonthlyHeader from './MonthlyHeader';
import { MONTHS, FIRST_INDEX, DAYS, DATE_FORMAT, HOUR_MINUTE_FORMAT, EMPTY_STRING, EMPTY_COUNT, ONE_DAY, ERROR, SHORT_TRUE, MOBILE_MONTHLY_LIST, HALF_HYPHEN, ERROR_BEHIND_DATA, MIN_TIME_LENGTH, MONTH, DEFAULT_TIMEZONE, SHORT_FALSE } from '../../../utils/constants';
import OrderMonthlyTable from './OrderMonthlyTable';
import { mobileOrdersOperations, mobileOrdersSelectors } from './state';
import { authOperations } from '../Login/state';
import { isNullOrEmpty, formatCurrency, getCurrentDate } from '../../../utils/common';
import ErrorAlert from '../../components/ErrorAlert';
import { ERROR_ORDER_ITEMS_MONTHLY_UPDATE, RELOAD_MASTER_UPDATED, ERROR_ORDER_ITEMS_MONTHLY_RETRIEVE } from '../../../utils/messages';
import Confirmation from '../../components/Confirmation';
import $ from 'jquery';
import SuccessAlert from '../../components/SuccessAlert';

class OrderMonthly extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filterDate: moment(),
            dayChecklist: [],
            error: [],
            success: [],
            reload: false,
            ...this.props.location.state && this.props.location.state
        };
    }

    componentWillMount() {
        this.props.setMobilePage(MOBILE_MONTHLY_LIST);

        let id = this.props.match.params.id;

        if (undefined !== this.props.location.state && undefined !== id) {
            this.getPredictions();
        } else {
            this.showList();
        }
    }

    getPredictions = () => {
        mobileOrdersSelectors.calculateMonthlyEstimate(this.props.location.state.details, this.state.filterDate)
            .then((result) => {
                this.setState({ predictions: result, error: [], success: [] },
                    () => this.generateDates()
                );
            }).catch(() => this.setState({ error: [ERROR_ORDER_ITEMS_MONTHLY_RETRIEVE], dayChecklist: [], success: [] }));
    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    handleInputChange = (e) => {
        let that = this;
        let input_id = e.target.id;
        this.setOrder(input_id, e.target.value);

        $(function() {
            $(`#${input_id}`).on('input', function() {
                if(EMPTY_COUNT !== this.value && EMPTY_STRING !== this.value){
                    this.value = this.value
                        .replace(/\b(0(?!\b))+/g, "")
                        .replace(/(^[\d]{10})[\d]/g, '$1') 
                        .replace(/(\..*)\./g, '')  
                }

                that.setOrder(input_id, this.value);
            });
        });
    }

    setOrder = (id, value) =>{
        let newAmt = Number(value);
            let newChecklist = Object.assign([], this.state.dayChecklist);

            if (EMPTY_STRING === value
                || EMPTY_COUNT === value) {
                newChecklist[id].orderedProducts = undefined;
            } else {
                newChecklist[id].orderedProducts = newAmt;
            }
            this.setState({ dayChecklist: newChecklist });
    }

    handleCheckboxChange = (e) => {
        let newChecklist = Object.assign([], this.state.dayChecklist);
        let id = (e.target.id).split('-')[1];
        newChecklist[id].isChecked = !newChecklist[id].isChecked;

        if (undefined === newChecklist[id].orderedProducts) {
            newChecklist[id].orderedProducts = 0;
        }

        this.setState({ dayChecklist: newChecklist });
    }

    handleSubmit = () => {
        let orderItems = this.state.dayChecklist.filter((checklist) => true === checklist.isChecked);

        let errorList = mobileOrdersSelectors.validate(orderItems, false);

        if (EMPTY_COUNT < errorList.length) {
            this.setState({ error: errorList, success: [] });
        } else {
            this.props.updateMonthlyOrders(orderItems, this.props.loginId)
                .then((result) => {
                    if (ERROR === result.status) {
                        if (ERROR_BEHIND_DATA === result.data) {
                            this.setState({ reload: true });
                        } else if (result.data instanceof Object) {
                            this.setState({ error: result.data, success: [] });
                        } else {
                            this.setState({ error: [result.message], success: [] });
                        }
                    } else {
                        this.setState({ success: [result.message], error: [] });
                        this.generateDates();
                    }
                }).catch(() => this.setState({ error: [ERROR_ORDER_ITEMS_MONTHLY_UPDATE], success: [] }))
        }
    }

    showList = () => {
        this.props.history.push(ORDER_LIST);
    }

    setNextDate = () => {
        this.setState({ filterDate: moment(this.state.filterDate).add(ONE_DAY, MONTHS) }, () => this.getPredictions());
    }

    setPrevDate = () => {
        this.setState({ filterDate: moment(this.state.filterDate).subtract(ONE_DAY, MONTHS) }, () => this.getPredictions());
    }

    setFetchParams = () => {
        return {
            proposalId: this.state.details.proposalId,
            shopMainNumber: this.state.details.shopMainNumber,
            shopBranchNumber: this.state.details.shopBranchNumber,
            productCode: this.state.details.productCode,
            deliveryDttm: this.state.filterDate,
            isMobile: true
        }
    }

    calculateDeadline = (orderDeadline) => {
        if (MIN_TIME_LENGTH === this.state.details.deadlineTime.length) {
            orderDeadline.add(this.state.details.deadlineTime.substring(0, 1), 'hours');
            orderDeadline.add(this.state.details.deadlineTime.substring(2, 3), 'minutes');
        } else {
            orderDeadline.add(this.state.details.deadlineTime.substring(0, 2), 'hours');
            orderDeadline.add(this.state.details.deadlineTime.substring(2, 4), 'minutes');
        }
    }

    setFlags = () => {
        return [
            this.state.details.sunFlag,
            this.state.details.monFlag,
            this.state.details.tueFlag,
            this.state.details.wedFlag,
            this.state.details.thuFlag,
            this.state.details.friFlag,
            this.state.details.satFlag
        ];
    }

    generateDates = () => {
        let dayChecklist = [];
        let details = this.state.details;
        let displayDate = moment(moment(this.state.filterDate).startOf(MONTH).format(DATE_FORMAT));
        let daysCount = moment(this.state.filterDate).daysInMonth();
        let startDate = moment(details.proposalStartDate).format(DATE_FORMAT);
        let endDate = moment(details.proposalEndDate).format(DATE_FORMAT);
        let delFlags = this.setFlags();
        let jpTime = moment().tz(DEFAULT_TIMEZONE);

        this.props.fetchDeadline(details.proposalId, displayDate).then((result) => {
            let orderDeadline = moment(result);
            this.props.fetchProductOrders(this.setFetchParams())
                .then((result) => {
                    let orderRecords = result.data;
                    for (let i = FIRST_INDEX; i < daysCount; i++) {
                        let formattedDate = displayDate.format(DATE_FORMAT);
                        if (moment(formattedDate).isBetween(startDate, endDate, null, '[]')) {
                            let newChecklist = Object.assign({}, this.state.details);
                            let strDate = moment(displayDate).format(DATE_FORMAT);
                            let currentOrder = orderRecords.filter((order) => moment(order.deliveryDate).format(DATE_FORMAT) === strDate);

                            if (delFlags[moment(strDate).day()] || EMPTY_COUNT < currentOrder.length) {
                                newChecklist.deliveryDate = moment(strDate).valueOf();
                                newChecklist.closingDeadline = orderDeadline.valueOf();
                                newChecklist.isChecked = false;

                                if (EMPTY_COUNT < currentOrder.length) {
                                    newChecklist.orderedProducts = currentOrder[FIRST_INDEX].orderedProducts;
                                    newChecklist.orderUpdateDttm = currentOrder[FIRST_INDEX].orderUpdateDttm;
                                    newChecklist.hasOrder = true;
                                    if(0 === currentOrder[FIRST_INDEX].updPgmId.localeCompare('true')){
                                        newChecklist.isPlainBG = false;
                                    }else{
                                        newChecklist.isPlainBG = true;
                                    }
                                } else {
                                    newChecklist.orderedProducts = undefined;
                                    newChecklist.orderUpdateDttm = null;
                                    newChecklist.hasOrder = false;
                                }

                                if (moment(orderDeadline).isBefore(jpTime)) {
                                    newChecklist.isDisabled = true;
                                } else {
                                    newChecklist.isDisabled = false;

                                    if (EMPTY_COUNT === currentOrder.length) {
                                        let prediction = this.state.predictions[i];
                                        newChecklist.orderedProducts = HALF_HYPHEN === prediction || SHORT_FALSE === newChecklist.displayForecast ? undefined : prediction;
                                    }
                                }
                                dayChecklist.push(newChecklist);
                            }
                        }
                        displayDate.add(ONE_DAY, DAYS);
                        orderDeadline.add(ONE_DAY, DAYS);
                    }
                    this.setState({ dayChecklist, error: []});
                })
                .catch(() => this.setState({ error: [ERROR_ORDER_ITEMS_MONTHLY_RETRIEVE], dayChecklist: [], success: [] }));
        }).catch(() => this.setState({ error: [ERROR_ORDER_ITEMS_MONTHLY_RETRIEVE], dayChecklist: [], success: [] }));;
    }

    hasNoValidOrder = () => {
        let currentDate = getCurrentDate();

        return EMPTY_COUNT >= this.state.dayChecklist.filter((checklist) => true === checklist.isChecked && EMPTY_STRING !== checklist.orderedProducts 
            && !(moment(checklist.deliveryDate).isBefore(currentDate) || (moment(checklist.deliveryDate).isSame(currentDate)
                && Number(this.state.details.deadlineTime) < moment().format(HOUR_MINUTE_FORMAT)))).length
    }

    showReload = () => {
        return this.state.reload && (
            <Confirmation
                message={RELOAD_MASTER_UPDATED}
                showConfirmation={true}
                buttons={[
                    { label: "OK", action: () => window.location.reload() },
                ]}
            />
        );
    }

    render() {
        if (undefined === this.props.location.state) {
            return EMPTY_STRING;
        }

        return (
            <Grid className="mobile-container">
                <Grid>

                    {this.showReload()}

                    <ErrorAlert errors={this.state.error} />
                    <SuccessAlert success={this.state.success} />

                    <div className="mb-15 mobile-product text-bold">
                        {this.state.details.productName1}
                        <br />
                        {this.state.details.productName2}
                        <span className="ml-100">
                            {(SHORT_TRUE === this.state.details.displayPrice && !isNullOrEmpty(this.state.details.strProposalPrice))
                                && `${formatCurrency(this.state.details.proposalPrice)}円`}
                        </span>
                    </div>

                    <MonthlyHeader
                        handleDateChangeRaw={this.handleDateChangeRaw}
                        handleSubmit={this.handleSubmit}
                        setNextDate={this.setNextDate}
                        setPrevDate={this.setPrevDate}
                        filterDate={this.state.filterDate}
                        disableSubmit={this.hasNoValidOrder()}
                    />

                    <OrderMonthlyTable
                        handleInputChange={this.handleInputChange}
                        handleCheckboxChange={this.handleCheckboxChange}
                        filterDate={this.state.filterDate}
                        dayChecklist={this.state.dayChecklist}
                        predictions={this.state.predictions}
                    />
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loginId: state.auth.credentials.user_cd,
        user: state.auth.partnerCodes,
    }
};

const mapDispatchToProps = {
    fetchProductOrders: mobileOrdersOperations.fetchProductOrders,
    updateMonthlyOrders: mobileOrdersOperations.updateMonthlyOrders,
    setMobilePage: authOperations.setMobilePage,
    fetchDeadline: mobileOrdersOperations.fetchDeadline,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderMonthly);